import React, { Component } from 'react'
import SignCard from './SignCard'
import EditCard from './EditCard'
import FinishCard from './FinishCard'
import DistCard from './DistCard'
import TaskCard from './TaskCard'
import AppointmentCard from './AppointmentCard'
import Content from './Content'
import ContactCard from './ContactCard'
import NotFollowCard from './NotFollowCard'
import CooperationCard from './CooperationCard'
import CooperateOrderCard from './CooperateOrderCard'
import { Spin } from 'hljd'
import { observer } from 'mobx-react'
import { dGet } from '@core/utils'

@observer
class Index extends Component {
  scrollToAnchor = anchorName => {
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName)
      if (anchorElement) {
        anchorElement.scrollIntoView()
      }
    }
  }

  render() {
    const {
      store: { loadingCards }
    } = this.props

    return (
      <div className="cards-wrap">
        <Spin spinning={loadingCards}>
          <Content
            renderItem={item => {
              const operator = dGet(item, 'operator.nick', '系统自动')

              switch (item.card_type) {
                case 'finish_card':
                  return (
                    <FinishCard
                      item={item}
                      operator={operator}
                      scrollToAnchor={this.scrollToAnchor}
                    />
                  )
                case 'appointment_card':
                  return <AppointmentCard item={item} operator={operator} />
                case 'distribution_card':
                  return <DistCard item={item} operator={operator} />
                case 'contact_card':
                  return <ContactCard item={item} operator={operator} />
                case 'signing_card':
                  return <SignCard item={item} operator={operator} />
                case 'cooperateorder_card':
                  return (
                    <CooperateOrderCard
                      store={this.props.store}
                      item={item}
                      operator={operator}
                    />
                  )
                case 'task_card':
                  return (
                    <TaskCard
                      store={this.props.store}
                      item={item}
                      operator={operator}
                    />
                  )
                case 'notfollow_card':
                  return <NotFollowCard item={item} operator={operator} />
                case 'cooperation_card':
                  return <CooperationCard item={item} operator={operator} />
                default:
                  // 修改客户信息卡片
                  return <EditCard item={item} operator={operator} />
              }
            }}
          />
        </Spin>
      </div>
    )
  }
}

export default Index
